{
  "userFetch": {
    "error": "Failed to retrieve user"
  },
  "userUpdate": {
    "success": "User has been updated successfully",
    "error": "Failed to update user"
  },
  "accountUpdate": {
    "success": "Your account has been updated successfully",
    "error": "Failed to update your account"
  }
}